module.exports = __webpack_public_path__ + "img/Logical-Framework.768e898a.png";